import type { MarlinStoreDb } from "../db";
import * as ops from "./store";

export const createAuditApi = (db: MarlinStoreDb) => ({
  findDanglingReferences: () => ops.findDanglingReferences(db),
});

export type AuditApi = ReturnType<typeof createAuditApi>;
